import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './plugins/i18n';
import api from './api';

// Global styles
import './assets/css/reset.css';
import './assets/css/main.css';

// 将API挂载到Vue原型上，方便全局使用
Vue.prototype.$api = api;

Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
